import { ENVIRONMENT } from './config';

export const trackListHub = (action, name, data) => {
  if (typeof window !== 'undefined' && !window.lh) {
    let snippet = document.createElement('script');
    snippet.text = `(function(l,i,s,t,h,u,b){l['ListHubAnalyticsObject']=h;l[h]=l[h]||function(){
          (l[h].q=l[h].q||[]).push(arguments)},l[h].d=1*new Date();u=i.createElement(s),
          b=i.getElementsByTagName(s)[0];u.async=1;u.src=t;b.parentNode.insertBefore(u,b)
        })(window,document,'script','//tracking.listhub.net/la.min.js','lh');
    
        lh('init', {provider:'M-5220', test:${
          ENVIRONMENT.toLowerCase() !== 'prod'
        }})
        lh('${action}', '${name}', ${JSON.stringify(data)});`;

    document.head.appendChild(snippet);
  } else if (typeof window !== 'undefined') {
    window.lh(action, name, data);
  }
};
